import { render, staticRenderFns } from "./templates/MainTemplate.html?vue&type=template&id=df12c916&scoped=true&external"
import script from "./FtuMaster.vue?vue&type=script&lang=js"
export * from "./FtuMaster.vue?vue&type=script&lang=js"
import style0 from "./FtuMaster.vue?vue&type=style&index=0&id=df12c916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df12c916",
  null
  
)

export default component.exports